import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import SubscriptionSection from '../components/SubscriptionSection';
import '../styles/LandscapeGarden.css';

const LandscapeGarden = () => {
  const [activeTab, setActiveTab] = useState('gioi-thieu');
  const [step, setStep] = useState(1);
  const [selectedProject, setSelectedProject] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // API configuration
  const API_BASE_URL = "https://phucansolutions.vn" ;

  // Fetch projects data
  useEffect(() => {
    const fetchProjects = async () => {
      try {
        setLoading(true);
        setError(null);
        
        console.log('🔄 Fetching landscape projects...');
        
        // Try to fetch projects by category first
        let response = await fetch(`${API_BASE_URL}/api/projects/category/landscape?limit=6`);
        
        if (!response.ok) {
          // If category endpoint fails, try featured projects
          response = await fetch(`${API_BASE_URL}/api/projects/featured?limit=6`);
        }

        if (response.ok) {
          const data = await response.json();
          const processedProjects = data.data?.map(processProject) || [];
          setProjects(processedProjects);
          console.log('✅ Landscape projects loaded:', processedProjects.length);
        } else {
          throw new Error('Failed to fetch projects');
        }
        
      } catch (err) {
        console.error('❌ Error fetching landscape projects:', err);
        setError(err.message);
        
        // Use fallback data if API fails
        setProjects(getFallbackProjects());
      } finally {
        setLoading(false);
      }
    };

    fetchProjects();
  }, [API_BASE_URL]);

  // Process project data from API
  const processProject = (project) => ({
    id: project.id,
    title: project.title,
    description: project.description || `Dự án ${project.title} - Thiết kế cảnh quan chuyên nghiệp`,
    image: getImageUrl(project.featured_image),
    technologies: project.technologies ? (typeof project.technologies === 'string' ? JSON.parse(project.technologies) : project.technologies) : ['Cảnh quan', 'Sân vườn'],
    status: project.status || 'completed',
    featured: project.is_featured || true,
    slug: project.slug,
    client: project.client_name,
    views: project.views_count || 0
  });

  // Get image URL
  const getImageUrl = (imagePath) => {
    if (!imagePath) return '/images/garden-villa-1.jpg';
    if (imagePath.startsWith('/uploads/')) return `${API_BASE_URL}${imagePath}`;
    return imagePath;
  };

  // Fallback projects data for landscape garden
  const getFallbackProjects = () => [
    {
      id: 1,
      title: 'Sân vườn biệt thự Thảo Điền',
      description: 'Thiết kế sân vườn 800m² phong cách Nhật Bản với hồ cá Koi, cầu gỗ và khu trà đạo.',
      image: '/images/garden-villa-1.jpg',
      technologies: ['Japanese Garden', 'Koi Pond', 'Tea House'],
      status: 'completed',
      featured: true
    },
    {
      id: 2,
      title: 'Cảnh quan Khách sạn Mường Thanh',
      description: 'Dự án cảnh quan 2ha với thác nước, vườn hoa, thảm cỏ và hệ thống chiếu sáng nghệ thuật.',
      image: '/images/garden-hotel-1.jpg',
      technologies: ['Waterfall Design', 'Landscape Lighting', 'Hotel Garden'],
      status: 'completed',
      featured: true
    },
    {
      id: 3,
      title: 'Vườn trên mái Bitexco Financial',
      description: 'Vườn trên mái 150m² tầng 30 với cây xanh chịu gió và hệ thống tưới tự động.',
      image: '/images/garden-rooftop-1.jpg',
      technologies: ['Rooftop Garden', 'Wind-resistant Plants', 'Auto Irrigation'],
      status: 'completed',
      featured: true
    },
    {
      id: 4,
      title: 'Công viên Ecopark Hà Nội',
      description: 'Thiết kế cảnh quan công viên 10ha với hồ sen, đường dạo bộ và khu vui chơi trẻ em.',
      image: '/images/garden-park-1.jpg',
      technologies: ['Public Park', 'Lotus Pond', 'Playground Design'],
      status: 'completed',
      featured: true
    }
  ];

  const handleViewDetails = (project) => {
    setSelectedProject(project);
    setIsModalOpen(true);
  };

  // Scroll to specific section
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  // Handle "TÌM HIỂU THÊM" button clicks
  const handleLearnMore = (type) => {
    scrollToSection('advantages-section');
  };

  const renderGioiThieu = () => (
    <div className="landscape-intro-content">
      <h2 className="section-title">Giải pháp cho tiểu cảnh sân vườn</h2>
      <div className="landscape-grid">
        {[
          { 
            title: 'Thiết kế & thi công', 
            subtitle: 'Cảnh quan',
            desc: 'Chúng tôi lên ý tưởng và triển khai quy hoạch tổng thể cho công viên, khu đô thị, resort hay sân golf, từ mặt bằng đến giao thông, hồ điều tiết và mảng xanh lớn. Dịch vụ bao trọn gói.', 
            img: '/images/Rectangle.png' 
          },
          { 
            title: 'Thiết kế & thi công', 
            subtitle: 'Sân vườn',
            desc: 'Dịch vụ chuyên biệt cho không gian xanh quanh nhà, biệt thự, café sân vườn hay văn phòng (50–500 m²). Chúng tôi kiến tạo khu vườn tiện ích, thẩm mỹ và dễ chăm sóc.', 
            img: '/images/Rectangle1.png' 
          },
          { 
            title: 'Thiết kế & thi công', 
            subtitle: 'Nhà vườn',
            desc: 'Giải pháp trọn gói kết hợp xây dựng nhà ở và cảnh quan liền mạch (100–1.000 m²): kiến trúc – kết cấu – M&E – nội thất đồng bộ với sân vườn, tiểu cảnh.', 
            img: '/images/Rectangle2.png' 
          },
          { 
            title: 'Thiết kế & thi công', 
            subtitle: 'Tiểu cảnh',
            desc: 'Thiết kế nhanh cho góc nhỏ (<5 m²): non bộ, bonsai, terrarium, aquascape, trong chậu hay bình thủy tinh... Giúp không gian bàn làm việc, ban công hay sảnh đón trở nên sinh động, tĩnh tại.', 
            img: '/images/Rectangle3.png' 
          }
        ].map((item, idx) => (
          <div key={idx} className="landscape-card">
            <img src={item.img} alt={item.title} className="landscape-card-image" />
            <div className="landscape-card-content">
              <h3>
                {item.title}
                <br />
                <span className="subtitle">{item.subtitle}</span>
              </h3>
              <p>{item.desc}</p>
              <button className="learn-more-btn" onClick={() => handleLearnMore('landscape')}>TÌM HIỂU THÊM</button>
            </div>
          </div>
        ))}
      </div>
      
      {/* Ưu điểm của giải pháp */}
      <div id="advantages-section" className="advantages-section">
        <h2 className="section-title">Ưu điểm của giải pháp</h2>
        <div className="advantages-content">
          <div className="advantage-item">
          <div className="advantage-image">
              <img src="/images/Rectangle4.png" alt="Mang lại sức sống cho không gian" />
            </div>
            <div className="advantage-text">
              <h3>Mang lại sức sống cho không gian</h3>
              <p>Tiểu cảnh giúp không gian trở nên sinh động và có hồn hơn nhờ cây xanh, nước chảy hay đá trang trí. Tạo cảm giác gần gũi thiên nhiên, tăng năng lượng tích cực cho toàn bộ ngôi nhà.</p>
            </div>
            
          </div>
          
          <div className="advantage-item">
            <div className="advantage-image">
              <img src="/images/Rectangle5.png" alt="Cân bằng độ ẩm – tốt cho sức khỏe" />
            </div>
            <div className="advantage-text">
              <h3>Cân bằng độ ẩm – tốt cho sức khỏe</h3>
              <p>Cây xanh trong tiểu cảnh giúp lọc không khí, cân bằng độ ẩm tự nhiên trong nhà. Điều này hỗ trợ hô hấp, cải thiện giấc ngủ và mang lại môi trường sống trong lành hơn.</p>
            </div>
          </div>
          
          <div className="advantage-item">
          <div className="advantage-image">
              <img src="/images/Rectangle6.png" alt="Thân thiện với thiên nhiên" />
            </div>
            <div className="advantage-text">
              <h3>Thân thiện với thiên nhiên</h3>
              <p>Tiểu cảnh sử dụng cây xanh, đá, nước và vật liệu tự nhiên giúp kết nối con người với môi trường. Đây là giải pháp sống xanh, góp phần bảo vệ thiên nhiên và nâng cao ý thức bền vững trong không gian sống.</p>
            </div>
            
          </div>
          
          <div className="advantage-item">
            <div className="advantage-image">
              <img src="/images/Rectangle7.png" alt="Tạo cảm giác thư giãn" />
            </div>
            <div className="advantage-text">
              <h3>Tạo cảm giác thư giãn</h3>
              <p>Âm thanh của nước, màu xanh dịu mát và bố cục hài hòa của tiểu cảnh giúp giảm căng thẳng, mệt mỏi sau ngày dài làm việc. Là góc thư giãn lý tưởng cho gia đình.</p>
            </div>
          </div>
          
          <div className="advantage-item">
          <div className="advantage-image">
              <img src="/images/Rectangle8.png" alt="Tăng tính thẩm mỹ và phong thủy" />
            </div>
            <div className="advantage-text">
              <h3>Tăng tính thẩm mỹ và phong thủy</h3>
              <p>Tiểu cảnh là điểm nhấn nghệ thuật giúp không gian thêm sang trọng, cuốn hút. Bố trí hợp phong thủy còn hỗ trợ luân chuyển sinh khí, thu hút tài lộc và mang lại may mắn cho gia chủ.</p>
            </div>
            
          </div>
        </div>
      </div>
    </div>
  );

  const renderLoiIch = () => (
    <div className="benefits-content">
      <div className="benefits-grid">
        {[
          { icon: '🌿', title: 'Không gian sống xanh', desc: 'Tạo không gian sống trong lành, thư giãn và gần gũi với thiên nhiên ngay tại ngôi nhà của bạn.' },
          { icon: '🏡', title: 'Tăng giá trị bất động sản', desc: 'Sân vườn đẹp làm tăng đáng kể giá trị ngôi nhà, tạo ấn tượng mạnh với khách tham quan.' },
          { icon: '💚', title: 'Tốt cho sức khỏe', desc: 'Cây xanh giúp lọc không khí, giảm stress, cung cấp không gian vận động và thư giãn tự nhiên.' },
          { icon: '🌡️', title: 'Điều hòa khí hậu', desc: 'Cây xanh giúp làm mát không khí, giảm nhiệt độ, tạo độ ẩm tự nhiên cho ngôi nhà.' }
        ].map((item, idx) => (
          <div key={idx} className="benefit-card">
            <div className="benefit-header">
              <div className="benefit-icon">
                <span>{item.icon}</span>
              </div>
              <h3>{item.title}</h3>
            </div>
            <p>{item.desc}</p>
          </div>
        ))}
      </div>
    </div>
  );

  const renderProjects = () => (
    <div className="projects-content">
      <h2 className="section-title">Dự án tiêu biểu</h2>
      
      {/* API Status Indicator */}
      {error && (
        <div className="api-status error">
          ⚠️ Đang sử dụng dữ liệu mẫu (API: {error})
        </div>
      )}
      
      {loading ? (
        <div className="loading-projects">
          <div className="loading-spinner"></div>
        </div>
      ) : (
        <div className="projects-grid">
          {projects.map((project) => (
            <div key={project.id} className="project-card">
              <img src={project.image} alt={project.title} className="project-image" />
              <div className="project-content">
                <h3>{project.title}</h3>
                <p>{project.description}</p>
                <div className="project-tech">
                  {project.technologies.slice(0, 3).map((tech, idx) => (
                    <span key={idx} className="tech-tag">{tech}</span>
                  ))}
                  {project.technologies.length > 3 && (
                    <span className="tech-tag extra">+{project.technologies.length - 3}</span>
                  )}
                </div>
                <div className="project-footer">
                  <span className="project-status">
                    {project.status === 'completed' ? '✅ Hoàn thành' : 
                     project.status === 'in-progress' ? '🔄 Đang thực hiện' : '📋 Lên kế hoạch'}
                  </span>
                  <button onClick={() => handleViewDetails(project)} className="view-details-btn">
                    Xem chi tiết →
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
      
      {/* Video Section */}
      <div className="video-section">
        <h3 className="video-title">Video dự án tiêu biểu</h3>
        <div className="video-container">
          <div className="video-player">
            <iframe
              src="https://www.youtube.com/embed/LOLiq4w7SEs"
              title="Dự án tiểu cảnh sân vườn"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
              className="video-iframe"
            />
          </div>
        </div>
      </div>
      
      {/* Partners Section */}
      <div className="partners-section">
        <h3 className="partners-title">Đối tác thương hiệu</h3>
        <div className="partners-grid">
          {[
            'asset1.png', 'asset3.png', 'asset4.png', 'asset5.png', 
            'asset6.png', 'asset7.png'
          ].map((partner, idx) => (
            <div key={idx} className="partner-logo">
              <img src={`/images/${partner}`} alt={`Partner ${idx + 1}`} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );

  const renderTabContent = () => {
    switch (activeTab) {
      case 'gioi-thieu': return renderGioiThieu();
      case 'loi-ich': return renderLoiIch();
      case 'quy-trinh': return (
        <div className="process-content">
          <h2 className="section-title">Quy trình thiết kế & thi công sân vườn</h2>
          <p className="process-description">Quy trình thiết kế và thi công sân vườn chuyên nghiệp từ khảo sát, thiết kế đến hoàn thiện và chăm sóc, đảm bảo cây xanh phát triển tốt nhất.</p>
          <div className="process-timeline">
            {[
              { title: 'BƯỚC 1: KHẢO SÁT & TƯ VẤN', icon: '/images/Untitled-1.png', content: 'Khảo sát thực địa, đo đạc diện tích, phân tích đất, ánh sáng, hướng gió. Tìm hiểu sở thích và nhu cầu của khách hàng để đưa ra phương án phù hợp.', image: '/images/Rectangle.png' },
              { title: 'BƯỚC 2: THIẾT KẾ SƠ BỘ', icon: '/images/Untitled-2.png', content: 'Lập bản thiết kế 2D, 3D cho sân vườn. Lựa chọn phong cách, màu sắc, loại cây và tiểu cảnh phù hợp.', image: '' },
              { title: 'BƯỚC 3: HOÀN THIỆN THIẾT KẾ', icon: '/images/Untitled-3.png', content: 'Điều chỉnh thiết kế theo ý kiến khách hàng. Lập danh sách cây xanh, vật liệu và dự toán chi tiết.', image: '' },
              { title: 'BƯỚC 4: CHUẨN BỊ VẬT TƯ', icon: '/images/Untitled-4.png', content: 'Đặt hàng cây xanh, đất trồng, phân bón, vật liệu trang trí và hệ thống tưới tiêu.', image: '' },
              { title: 'BƯỚC 5: CHUẨN BỊ MẶT BẰNG', icon: '/images/Untitled-5.png', content: 'San lấp mặt bằng, tạo địa hình, đào hố trồng cây, lắp đặt hệ thống tưới và thoát nước.', image: '' },
              { title: 'BƯỚC 6: TRỒNG CÂY & TRANG TRÍ', icon: '/images/Untitled-6.png', content: 'Trồng cây theo đúng thiết kế, bố trí tiểu cảnh, lắp đặt đèn trang trí và các phụ kiện.', image: '' },
              { title: 'BƯỚC 7: HOÀN THIỆN & BÀN GIAO', icon: '/images/Untitled-7.png', content: 'Kiểm tra toàn bộ hệ thống, vệ sinh sân vườn, hướng dẫn cách chăm sóc và bàn giao cho khách hàng.', image: '' },
              { title: 'BƯỚC 8: BẢO HÀNH & CHĂM SÓC', icon: '/images/Untitled-8.png', content: 'Chăm sóc cây xanh trong thời gian bảo hành, thay thế cây chết, tư vấn cách bảo dưỡng lâu dài.', image: '' }
            ].map((s, idx) => (
              <div key={idx} className={`process-step ${step === idx + 1 ? 'active' : ''}`}>
                <div className={`step-wrapper ${idx % 2 === 0 ? 'left' : 'right'}`}>
                  <button onClick={() => setStep(idx + 1)} className="step-button">
                    <img src={s.icon} alt={s.title} className="step-icon" />
                    <span className="step-title">{s.title}</span>
                  </button>
                  <div className="timeline-dot"></div>
                </div>
                {step === idx + 1 && (
                  <div className="step-detail">
                    <div className="step-detail-content">
                      <h3>{s.title}</h3>
                      <p>{s.content}</p>
                    </div>
                    {s.image && (
                      <div className="step-detail-image">
                        <img src={s.image} alt={s.title} />
                      </div>
                    )}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      );
      case 'du-an': return renderProjects();
      default: return null;
    }
  };

  return (
    <main className="landscape-main">
      {/* Hero Banner */}
      <div className="hero-banner">
        <img src="/images/Rectangle11.png" alt="Landscape Garden Banner" className="hero-image" />
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <h1>TIỂU CẢNH SÂN VƯỜN</h1>
          <p>Thiết kế và thi công tiểu cảnh sân vườn chuyên nghiệp. Tạo không gian xanh thư giãn và gần gũi với thiên nhiên ngay tại ngôi nhà của bạn.</p>
        </div>
      </div>

      {/* Navigation Tabs */}
      <div className="tab-navigation">
        <button 
          onClick={() => setActiveTab('gioi-thieu')}
          className={`tab-btn ${activeTab === 'gioi-thieu' ? 'active' : ''}`}
        >
          GIỚI THIỆU
        </button>
        <button 
          onClick={() => setActiveTab('quy-trinh')}
          className={`tab-btn ${activeTab === 'quy-trinh' ? 'active' : ''}`}
        >
          QUY TRÌNH
        </button>
        <button 
          onClick={() => setActiveTab('du-an')}
          className={`tab-btn ${activeTab === 'du-an' ? 'active' : ''}`}
        >
          DỰ ÁN TIÊU BIỂU
        </button>
      </div>

      {/* Tab Content */}
      <div className="tab-content">
        {renderTabContent()}
      </div>

      {/* Project Modal */}
      {isModalOpen && selectedProject && (
        <div className="modal-overlay" onClick={() => setIsModalOpen(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={() => setIsModalOpen(false)}>×</button>
            <img src={selectedProject.image} alt={selectedProject.title} className="modal-image" />
            <div className="modal-body">
              <h2>{selectedProject.title}</h2>
              <p>{selectedProject.description}</p>
              <div className="modal-tech">
                {selectedProject.technologies.map((tech, idx) => (
                  <span key={idx} className="tech-tag">{tech}</span>
                ))}
              </div>
              {selectedProject.client && (
                <div className="project-info">
                  <p><strong>Khách hàng:</strong> {selectedProject.client}</p>
                </div>
              )}
              {selectedProject.views > 0 && (
                <div className="project-stats">
                  <p>👁️ {selectedProject.views} lượt xem</p>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Subscription Section */}
      <SubscriptionSection />
    </main>
  );
};

export default LandscapeGarden; 